import { render, staticRenderFns } from "./WordTeaser.vue?vue&type=template&id=1bbf5f78&scoped=true&"
import script from "./WordTeaser.vue?vue&type=script&lang=js&"
export * from "./WordTeaser.vue?vue&type=script&lang=js&"
import style0 from "./WordTeaser.vue?vue&type=style&index=0&id=1bbf5f78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbf5f78",
  null
  
)

export default component.exports